import {HotelClass, HotelMealPlan, HotelRoomCategory, HotelScope} from "../../../api/model/activity-hotel";

export interface HotelClassForDropdown {
    name: string,
    id: number,
    value: HotelClass
}

export const zeroStar: HotelClassForDropdown = {
    id: 1,
    name: 'ACTIVITIES.HOTEL.HOTEL_CLASS_UNKNOWN',
    value: HotelClass.zero
};
export const oneStar: HotelClassForDropdown = {id: 2, name: '1', value: HotelClass.one};
export const twoStar: HotelClassForDropdown = {id: 3, name: '2', value: HotelClass.two};
export const threeStar: HotelClassForDropdown = {id: 4, name: '3', value: HotelClass.three};
export const fourStar: HotelClassForDropdown = {id: 5, name: '4', value: HotelClass.four};
export const fiveStar: HotelClassForDropdown = {id: 6, name: '5', value: HotelClass.five};
export const HOTEL_CLASSES = [
    zeroStar, oneStar, twoStar, threeStar, fourStar, fiveStar
];

export interface RoomCategory {
    name: string,
    id: number,
    value: HotelRoomCategory
}

export const singleStandard: RoomCategory = {
    id: 1,
    name: 'SCREENS.HOTEL.ROOM_CATEGORY_SS',
    value: HotelRoomCategory.SS
};
export const doubleStandard: RoomCategory = {
    id: 2,
    name: 'SCREENS.HOTEL.ROOM_CATEGORY_DS',
    value: HotelRoomCategory.DS
};
export const singlePremium: RoomCategory = {id: 3, name: 'SCREENS.HOTEL.ROOM_CATEGORY_SP', value: HotelRoomCategory.SP};
export const doublePremium: RoomCategory = {id: 4, name: 'SCREENS.HOTEL.ROOM_CATEGORY_DP', value: HotelRoomCategory.DP};
export const suite: RoomCategory = {id: 5, name: 'SCREENS.HOTEL.ROOM_CATEGORY_S', value: HotelRoomCategory.S};
export const ROOM_CLASSES = [
    singleStandard, doubleStandard, singlePremium, doublePremium, suite
];
export const getRoomCategory = (roomCategory: HotelRoomCategory | null): RoomCategory | null | undefined => {
    switch (roomCategory) {
        case HotelRoomCategory.SS:
            return singleStandard;
        case HotelRoomCategory.DS:
            return doubleStandard;
        case HotelRoomCategory.SP:
            return singlePremium;
        case HotelRoomCategory.DP:
            return doublePremium;
        case HotelRoomCategory.S:
            return suite;
        default:
            if (roomCategory === null) return null
            roomCategory satisfies never;
    }
};

export interface MealPlan {
    name: string,
    id: number,
    value: HotelMealPlan
}

export const roomOnly: MealPlan = {id: 1, name: 'SCREENS.HOTEL.MEAL_CLASS_OV', value: HotelMealPlan.OV};
export const breakfast: MealPlan = {id: 2, name: 'SCREENS.HOTEL.MEAL_CLASS_ÜF', value: HotelMealPlan.ÜF};
export const halfBoard: MealPlan = {id: 3, name: 'SCREENS.HOTEL.MEAL_CLASS_HP', value: HotelMealPlan.HP};
export const fullBoard: MealPlan = {id: 4, name: 'SCREENS.HOTEL.MEAL_CLASS_VP', value: HotelMealPlan.VP};
export const allInclusive: MealPlan = {id: 5, name: 'SCREENS.HOTEL.MEAL_CLASS_AI', value: HotelMealPlan.AI};
export const MEAL_CLASSES = [
    roomOnly, breakfast, halfBoard, fullBoard, allInclusive
];
export const getMealPlan = (mealPlan: HotelMealPlan | null): MealPlan | null | undefined => {
    switch (mealPlan) {
        case HotelMealPlan.OV:
            return roomOnly;
        case HotelMealPlan.ÜF:
            return breakfast;
        case HotelMealPlan.HP:
            return halfBoard;
        case HotelMealPlan.VP:
            return fullBoard;
        case HotelMealPlan.AI:
            return allInclusive;
        default:
            if (mealPlan === null) return null
            mealPlan satisfies never
    }
};
export const getScopeTranslationKey = (scope: HotelScope): string | undefined => {
    switch (scope) {
        case HotelScope.property:
            return "SCREENS.HOTEL.PROPERTY";
        case HotelScope.city:
            return "SCREENS.HOTEL.CITY";
        case HotelScope.region:
            return "SCREENS.HOTEL.REGION";
        case HotelScope.country:
            return "SCREENS.HOTEL.COUNTRY";
        default:
            scope satisfies never;
    }
};